import { useTranslation } from "react-i18next";
import {
  PRE_ACTIVATION_FIELD_AGENCY_JOB_TITLE,
  PRE_ACTIVATION_FIELD_AGENCY_USER_EMAIL,
  PRE_ACTIVATION_FIELD_AGENCY_USER_FULL_NAME,
  PRE_ACTIVATION_PLACEHOLDER_AGENCY_JOB_TITLE,
  PRE_ACTIVATION_PLACEHOLDER_EMAIL,
  PRE_ACTIVATION_PLACEHOLDER_FULL_NAME,
} from "../../../i18n/keysTranslations";
import TextFieldBlock from "./TextFieldBlock";

const PersonFields = ({
  prefix,
  control,
  errors,
  readOnly,
  required = true,
  showJobTitle = true,
  showEmail = true,
  hideFieldLabels = false,
}) => {
  const { t } = useTranslation();
  const fullNameLabel = t(PRE_ACTIVATION_FIELD_AGENCY_USER_FULL_NAME);
  const jobTitleLabel = t(PRE_ACTIVATION_FIELD_AGENCY_JOB_TITLE);
  const emailLabel = t(PRE_ACTIVATION_FIELD_AGENCY_USER_EMAIL);
  const emailPlaceholder = t(PRE_ACTIVATION_PLACEHOLDER_EMAIL);

  return (
    <>
      <TextFieldBlock
        name={`${prefix}.fullName`}
        label={fullNameLabel}
        placeholder={
          hideFieldLabels
            ? fullNameLabel
            : t(PRE_ACTIVATION_PLACEHOLDER_FULL_NAME)
        }
        required={required}
        showLabel={!hideFieldLabels}
        control={control}
        errors={errors}
        readOnly={readOnly}
      />
      {showJobTitle ? (
        <TextFieldBlock
          name={`${prefix}.jobTitle`}
          label={jobTitleLabel}
          placeholder={
            hideFieldLabels
              ? jobTitleLabel
              : t(PRE_ACTIVATION_PLACEHOLDER_AGENCY_JOB_TITLE)
          }
          required={required}
          showLabel={!hideFieldLabels}
          control={control}
          errors={errors}
          readOnly={readOnly}
        />
      ) : null}
      {showEmail ? (
        <TextFieldBlock
          name={`${prefix}.email`}
          label={emailLabel}
          placeholder={emailPlaceholder}
          required={required}
          showLabel={!hideFieldLabels}
          control={control}
          errors={errors}
          readOnly={readOnly}
          type="email"
        />
      ) : null}
    </>
  );
};

export default PersonFields;
